export const IN_HOUSE_OFFER_SECTIONS = [
    { key: "ON_THE_HOUSE", label: "ON THE HOUSE", subtitle: "Select up to 1 Complimentary" },
    { key: "DISCOUNT_OFFERS", label: "DISCOUNT OFFERS", subtitle: "Save more on this booking" },
    { key: "MORE_FOR_YOUR_BOOKING", label: "MORE FOR YOUR BOOKING", subtitle: "Enhance your booking with curated add-ons." },
];
const CRITERIA_TYPE_TO_SECTION = {
    FOOD_OFFERS: "ON_THE_HOUSE",
    DRINKS_OFFERS: "ON_THE_HOUSE",
    BILL_DISCOUNT: "DISCOUNT_OFFERS",
    TABLE_DISCOUNTS: "DISCOUNT_OFFERS",
    COMBOS: "MORE_FOR_YOUR_BOOKING",
    INSTANT_OFFERS: "MORE_FOR_YOUR_BOOKING",
    PACKAGES: "MORE_FOR_YOUR_BOOKING",
    CORPORATE_PACKAGES: "MORE_FOR_YOUR_BOOKING",
    LOYALTY_DISCOUNT: "MORE_FOR_YOUR_BOOKING",
    CUSTOM_OFFERS: "MORE_FOR_YOUR_BOOKING",
};
export const getOfferSection = (offer) => {
    var _a, _b;
    const t = (_b = (_a = offer.criteria) === null || _a === void 0 ? void 0 : _a.type) === null || _b === void 0 ? void 0 : _b.toUpperCase();
    return (t && CRITERIA_TYPE_TO_SECTION[t]) || "MORE_FOR_YOUR_BOOKING";
};
export const groupOffersBySection = (offers) => {
    const initial = {
        ON_THE_HOUSE: [],
        DISCOUNT_OFFERS: [],
        MORE_FOR_YOUR_BOOKING: [],
    };
    for (const o of offers)
        initial[getOfferSection(o)].push(o);
    return initial;
};
